module.exports = __webpack_public_path__ + "img/logo.8cce930c.svg";